import type { SVGProps } from "react";

export const DismissCircleFilledIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill={props.fill || "none"}
    viewBox="0 0 16 16"
    {...props}>
    <path
      fill={props.fill || "#fff"}
      d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0ZM5.81 5.114a.5.5 0 0 0-.638.058l-.058.069a.5.5 0 0 0 .058.638L7.292 8l-2.12 2.121-.058.07a.5.5 0 0 0 .058.637l.069.058a.5.5 0 0 0 .638-.058L8 8.708l2.121 2.12.07.058a.5.5 0 0 0 .637-.058l.058-.069a.5.5 0 0 0-.058-.638L8.708 8l2.12-2.121.058-.07a.5.5 0 0 0-.058-.637l-.069-.058a.5.5 0 0 0-.638.058L8 7.292l-2.121-2.12-.07-.058Z"
    />
  </svg>
);
